export const GoogleButton = ({ onClick, label = "Continue with Google", testId = "google-signin-btn", className = "" }) => (
  <button
    type="button"
    onClick={onClick}
    data-testid={testId}
    className={`inline-flex items-center justify-center gap-3 rounded-full bg-white border border-[#120716]/15 hover:border-[#E84C4C]/60 text-[#120716] font-semibold px-7 py-3.5 shadow-sm hover:shadow-[0_10px_30px_rgba(232,76,76,0.15)] transition-all duration-300 ${className}`}
  >
    <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
      <path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9.1 3.6l6.8-6.8C35.8 2.5 30.3 0 24 0 14.6 0 6.5 5.4 2.6 13.3l7.9 6.1C12.4 13.6 17.7 9.5 24 9.5z" />
      <path fill="#4285F4" d="M46.5 24.5c0-1.6-.1-2.8-.4-4.1H24v7.8h12.7c-.3 2.1-1.7 5.3-4.8 7.4l7.4 5.7c4.4-4.1 7.2-10.1 7.2-16.8z" />
      <path fill="#FBBC05" d="M10.5 28.6A14.5 14.5 0 0 1 9.7 24c0-1.6.3-3.2.8-4.6l-7.9-6.1A24 24 0 0 0 0 24c0 3.9.9 7.5 2.6 10.7l7.9-6.1z" />
      <path fill="#34A853" d="M24 48c6.5 0 11.9-2.1 15.9-5.8l-7.4-5.7c-2 1.4-4.7 2.4-8.5 2.4-6.3 0-11.6-4.1-13.5-9.9l-7.9 6.1C6.5 42.6 14.6 48 24 48z" />
    </svg>
    {label}
  </button>
);
